(function () {
  'use strict';

  //Internal constant values
  var wsConstants = {
    unknownActorName: 'UNKNOWN NAME',
    allGroup: {
      name: "All parts of your organization",
      id: -1,
      type: {
        id: -1,
        "name": "All"
      },
      isAll: true
    },
    groupCardTemplateName: 'card-group',
    interactionsTemplateName: 'interactions',
    secondsPerMinute: 60,
    secondsPerHour: 3600,
    secondsPerDay: 86400,
    secondsPerMonth: 2629800,
    // 365.25 days / 12
    secondsPerYear: 31557600,
    // 365.25 days
    correlationThresholds: {
      coefficient: 0.6,
      strongCoefficient: 0.8,
      pValue: 0.1,
      strongPValue: 0.05
    },
    fontStack: {
      body: 'Roboto, Arial, sans-serif',
      nav: 'DM Sans, Arial, sans-serif',
      code: 'Menlo, Monaco, Consolas, "Courier New", monospace'
    },
    responsiveReports: {
      pointWidth: {
        bar: 10,
        column: 10
      }
    }
  };
  var wsColors = {
    wsBlue: '#0DBBED',
    wsBlueLight: '#deedfa',
    wsBlueLighter: '#e7f4ff',
    wsBlueDark: '#252447',
    wsBlueDarker: '#006691',
    wsGray: "#555555",
    wsGrayLight: '#999999',
    wsGrayLighter: '#e5e5e5',
    wsGrayLightest: '#f5f5f5',
    wsGrayDark: '#333',
    colorBorder: '#fafafa',
    colorVizBlue: '#0DBBED',
    colorVizBlueLight: '#deedfa',
    colorVizGrayLight: '#999999',
    wsLightRed: '#f4b7b5',
    wsRed: '#e66665',
    wsRedDark: '#bf4b4b',
    wsRedMedium: '#eb8686',
    wsLightGreen: '#c9e6bd',
    wsGreen: '#97C772',
    wsGreenMedium: '#a5d690',
    wsGreenDark: '#6aa352',
    wsWhite: '#FFFFFF',
    wsBlack: '#000000',
    wsYellow: '#e4d354',
    wsPurple: '#9013FE',
    wsAquaBlue: '#91e8e1',
    vizCol1: '#0DBBED',
    vizCol2: '#97C772',
    vizCol3: '#E82E80',
    vizCol4: '#894996',
    vizCol5: '#ED6D05',
    vizCol6: '#005EA2',
    vizCol7: '#368153',
    vizCol8: '#eb9ad3',
    vizCol9: '#8a8036',
    vizCol10: '#804c19',
    vizCol11: '#B5DFF7',
    vizCol12: '#134a28',
    vizCol13: '#683d9c',
    vizCol14: '#3c3b36',
    vizCol15: '#6d6e71',
    getRGBObject: function getRGBObject(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    getRGB: function getRGB(hex) {
      var rgb = wsColors.getRGBObject(hex);
      if (rgb) {
        return 'rgb(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ')';
      }
      return null;
    },
    getRGBA: function getRGBA(hex, alpha) {
      var rgb = wsColors.getRGBObject(hex);
      if (rgb) {
        return 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + alpha + ')';
      }
      return null;
    },
    getVizColors: function getVizColors() {
      return [wsColors.vizCol1, wsColors.vizCol2, wsColors.vizCol3, wsColors.vizCol4, wsColors.vizCol5, wsColors.vizCol6, wsColors.vizCol7, wsColors.vizCol8, wsColors.vizCol9, wsColors.vizCol10, wsColors.vizCol11, wsColors.vizCol12, wsColors.vizCol13, wsColors.vizCol14, wsColors.vizCol15];
    }
  };
  var wsEventNames = {
    dashboard: {
      added: 'dashboard:added',
      deleted: 'dashboard:deleted',
      changed: 'dashboard:changed',
      selected: 'dashboard:selected'
    },
    viewDashboardsAs: {
      show: 'view-dashboards-as:show',
      active: 'view-dashboards-as:active'
    },
    pager: {
      setPage: 'pager:set-page',
      setPickerPage: 'pager:set-picker-page'
    },
    card: {
      change: {
        dashboards: 'card:change:dashboards'
      },
      preview: {
        loaded: 'card:preview:loaded'
      },
      rename: "card:rename:"
    },
    nav: {
      update: 'nav:update'
    },
    explorer: {
      change: {
        cardTitle: "explorer:card-title:changed",
        cardDescription: "explorer:card-description:changed",
        cardSummary: "explorer:card-summary:changed"
      }
    },
    cardDisplay: {
      prepareDisplay: 'card-display:prepare-display',
      layoutComplete: 'card-display:layout-complete'
    },
    cardLoader: {
      loadCards: 'card-loader:load-cards'
    },
    dataTable: {
      updateSort: 'data-table:update-sort'
    }
  };

  //Register constants
  angular.module('wsLrs.constants', []).constant('wsConstants', wsConstants).constant('wsColors', wsColors).constant('wsEventNames', wsEventNames);
})();
